import React from "react";
import { formatarData } from "../../../../components/Formatters/DateTime";

const ParcelamentoCard = ({ parcelamento }) => (
  <div className="col-lg-12">
    <div className="card shadow mb-1">
      <div className="card-header">
        <b>Parcelamentos</b>
      </div>
      <div className="card-body">
        <center>
          <table className="table table-striped table-bordered" width="100%">
            <thead>
              <tr>
                <th>
                  <center>Protocolo</center>
                </th>
                <th>
                  <center>Tipo Parcelamento</center>
                </th>
                <th>
                  <center>Status</center>
                </th>
                <th>
                  <center>Valor parcelado (R$)</center>
                </th>
                <th>
                  <center>Data da inclusão</center>
                </th>
              </tr>
            </thead>
            <tbody>
              {parcelamento?.map((parcela) => (
                <tr>
                  <td>
                    <center>{parcela.numeroProtocoloGeral}</center>
                  </td>
                  <td>
                    <center>{parcela.tipoRegraParcelamento}</center>
                  </td>
                  <td>
                    <center>{parcela.status}</center>
                  </td>
                  <td align="right">
                    {parcela.valorParcelamentoAtual.toLocaleString("pt-br", { minimumFractionDigits: 2 })}
                  </td>
                  <td>
                    <center>{formatarData(parcela.dataInclusao, "dd/MM/yyyy")}</center>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </center>
      </div>
    </div>
  </div>
);

export default ParcelamentoCard;
